<template>
  <!-- 通用模块 >>> 导入 >>> 保存类型 -->
  <vea-dialog
    ref="queryDialog"
    append-to-body
    class="create_dialog"
    :title="$t('tableImport.title')"
    :show="showDialog"
    :before-close="beforeShut"
  >
    <div slot="title" class="dialog_title">
      <svg-icon icon-class="warn" />
      {{$t('tableImport.title')}}
    </div>

    <div class="dialog_content">
      <el-radio-group v-model="importType">
        <el-radio :disabled="!moduleConfig.caninsert" :label="1">{{$t('tableImport.radio1')}}</el-radio>
        <el-radio :disabled="!moduleConfig.canedit" :label="2">{{$t('tableImport.radio2')}}</el-radio>
      </el-radio-group>
    </div>
    <!-- 底部 -->
    <div slot="footer-right" class="dialog_btn">
      <el-button plain v-preventReClick @click="hideDialog('cancel')">{{$t('module.cancel')}}</el-button>
      <el-button
        type="primary"
        :disabled="!importType"
        v-preventReClick
        @click="hideDialog('confirm')"
      >{{$t('module.confirm')}}</el-button>
    </div>
  </vea-dialog>
</template>
<script>
export default {
  props: {
    show: Boolean,
    content: {
      // 提示内容
      type: String,
      default: ''
    },
    moduleConfig: {
      // 模块配置信息
      type: Object,
      required: true
    },
    beforeClose: {
      type: Function,
      default: (action, done) => done()
    }
  },
  data() {
    return {
      showDialog: false,
      importType: null // 保存类型
    }
  },
  watch: {
    show: {
      handler(n) {
        this.showDialog = n
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.showDialog = false
    },
    // 隐藏报表参数弹窗
    hideDialog(action) {
      if (this.beforeClose.name.indexOf('default') > -1) {
        // name：开发环境 _default 生产环境 default
        this.close()
      } else {
        // @todo 添加loading效果等待父组件: done(true/false)
        this.beforeClose(action, this.close)
      }
    },
    // 弹窗关闭前回调方法
    beforeShut(action, done) {
      this.beforeClose(action, done)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
// 内部弹窗：输入报表参数
.create_dialog {
  /deep/.el-dialog {
    width: 500px;
    // min-height: 280px;
    .el-dialog__header {
      .reports_title_box {
        .reports_title {
          .dialog_title {
            @include flexCenter;
            svg {
              @include wh(20px, 20px);
              color: #fff;
              margin-right: 6px;
            }
          }
        }
      }
    }
    .el-dialog__body {
      padding: 20px;
      padding-bottom: 0;
      @include flexCenter;
      .dialog_content {
        width: 100%;
        height: 100%;
        svg {
          @include wh(38px, 38px);
          color: rgb(250, 173, 20);
          margin-right: 8px;
        }
        .el-radio-group {
          max-height: 100%;
          display: flex;
          flex-direction: column;
          // justify-content: center;
          .el-radio {
            // width: 50%;
            margin-bottom: 20px;

            padding: 5px 20px;
            display: flex;
            align-items: center;
            .el-radio__label {
              // font-size: 16px;
            }
          }
          .el-radio:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .el-dialog__footer {
      .dialog_btn {
      }
    }
  }
}
</style>
